import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ROUTE_LOGIN } from "../../constants";
import { useAuthState } from "../../context/UserAuthentication";
import { HandleFallBackUrlsContext } from '../../context/HandleFallBackUrlsContext';
import Spinner from "../Spinner/Spinner";

interface PrivateRouteProps {
  Component: React.ComponentType<any>;
}

const RequireAuth: React.FC<PrivateRouteProps> = ({ Component }) => {
  const location = useLocation();
  const { authInfo } = useAuthState();
  const { handleFallBackUrlsLoading } = useContext(HandleFallBackUrlsContext);

  if (handleFallBackUrlsLoading) {
    return <Spinner lightBg={true} />;
  }

  const element = authInfo.authentication_token ? (
    <Component />
  ) : (
    <Navigate to={ROUTE_LOGIN} state={{ referrer: location.pathname }} replace />
  );

  return element;
};

export default RequireAuth;
